module.exports = __webpack_public_path__ + "img/checklist.a13e76fe.png";